import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getShifts, uploadSchedule } from "./shiftApi";

export const getShiftRequest = createAsyncThunk(
  "getShiftRequest/shift",
  async () => {
    try {
      const response = await getShifts();
      return response;
    } catch (error) {}
  }
);

export const uploadScheduleRequest = createAsyncThunk(
  "uploadSchedule/shift",
  async (payload: any) => {
    try {
      const response = await uploadSchedule(payload);
      return response;
    } catch (error) {}
  }
);

interface IInitialState {
  shiftLists: any;
  pageIsLoading: boolean;
  message: string;
  postSchedule: any;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  shiftLists: [],
  pageIsLoading: false,
  message: "",
  postSchedule: {},
  isSuccess: false,
};

const shiftSlice = createSlice({
  name: "shift",
  initialState: initialState,
  reducers: {
    resetMessageShift: (state) => {
      state.message = "";
    },
    resetSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get shift
    builder.addCase(getShiftRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getShiftRequest.fulfilled, (state, action) => {
      if (action.payload && action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.shiftLists = action.payload.data;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getShiftRequest.rejected, (state) => {
      state.message = "Get Schedule is Fail";
      state.pageIsLoading = false;
    });

    // upload schedule
    builder.addCase(uploadScheduleRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(uploadScheduleRequest.fulfilled, (state, action) => {
      console.log(action.payload);

      if (action.payload.status === 1000) {
        state.postSchedule = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else if (action.payload.status === 2000) {
        state.message = "File not Found";
        state.pageIsLoading = false;
      } else if (action.payload.status === 2001) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(uploadScheduleRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageShift, resetSuccess } = shiftSlice.actions;
export default shiftSlice.reducer;
